import account from "./account";
import certificate from "./certificate";
import staging from "./staging";
import release from "./release";

const api:any = {
  ...account,
  ...certificate,
  ...staging,
  ...release,
};

export default api;
